module.exports = __webpack_public_path__ + "static/media/icon-video-minimize.8583dda8.svg";